import { ResourceList } from "./ResourceList";

export function ResourceCenter(): JSX.Element {
  return (
    <div className="w-full flex flex-col md:flex-row">
      <div className="w-full lg:px-5 flex flex-col gap-y-2 mb-3">
        <ResourceList />
      </div>
    </div>
  );
}
